import React from 'react';
import { Spline, TreeDeciduous } from 'lucide-react';
import { tramoCorto } from 'lib/lineasCache';
import ElegirElementos from './ElegirElementos';

// "¿Qué árbol?" del ítem fitosanitario en Alerta o Falla (código y qué
// sostiene).
//   arboles      [{ id, codigo, especie, sostiene }]
export default function ElegirArboles({ arboles, elegidos, onCambiar, obligatorio, idBase }) {
  return (
    <ElegirElementos
      elementos={arboles.map((a) => ({ id: a.id, codigo: a.codigo, secundario: a.sostiene || a.especie }))}
      elegidos={elegidos}
      onCambiar={onCambiar}
      obligatorio={obligatorio}
      idBase={idBase}
      sufijo="arboles"
      icono={TreeDeciduous}
      atributo="data-arbol"
      textos={{
        pregunta: '¿Qué árbol?',
        falta: 'Obligatorio: elija al menos un árbol. Puede elegir varios.',
        fuera: 'Árbol fuera de la lista',
      }}
    />
  );
}

// "¿Qué cable?" de "Estado del cable" y "Punto de anclaje" en Alerta o Falla
// (código y tramo).
//   lineas       [{ id, codigo, nombre, plataforma_desde, plataforma_hasta }]
export function ElegirLineas({ lineas, elegidos, onCambiar, obligatorio, idBase }) {
  return (
    <ElegirElementos
      elementos={lineas.map((l) => ({ id: l.id, codigo: l.codigo, secundario: tramoCorto(l) }))}
      elegidos={elegidos}
      onCambiar={onCambiar}
      obligatorio={obligatorio}
      idBase={idBase}
      sufijo="lineas"
      icono={Spline}
      atributo="data-linea"
      textos={{
        pregunta: '¿Qué cable?',
        falta: 'Obligatorio: elija al menos un cable. Puede elegir varios.',
        fuera: 'Cable fuera de la lista',
      }}
    />
  );
}
